export default __webpack_public_path__ + "static/media/racelog_white.34d19fc9.png";